import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, map, tap , share} from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { LoadingService } from "../shared/services/loading.service";
import { SkipLoaderService } from "../shared/services/skip-loader.service";
import { StorageService } from "../shared/services/storage.service";

@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(
    private readonly loader: LoadingService, 
    private readonly toastr: ToastrService,
    private readonly skipLoaderService: SkipLoaderService,
    private readonly storageService: StorageService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const user = this.storageService.getFromLocalOrSessionStorage("user");
    if (user && user.token) {
      request = request.clone({
        headers: request.headers.set("Authorization", "Bearer " + user.token),
      });
    }

    request = request.clone({
      headers: request.headers.set("Accept", "application/json"),
    });

    const skipLoader = this.skipLoaderService.getSkipLoader();
    
    if (!skipLoader) {
      this.loader.show();
    }
    
    const req: Observable<HttpEvent<any>> = next
      .handle(request)
      .pipe(
        share(),
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
          if (request.method !== 'GET') {
            if (event?.body?.success) {
              this.toastr.success(event.body.message, '', {});
            } else if (!event?.body?.success) {
              this.toastr.error(event.body.message, 'Attenzione!', {});
            }
          }
        }
        }),
        catchError((err) => {
          if (err.status === 401 && !window.location.href.includes("/pages/login") && !window.location.href.includes("/auth/login")) {
            this.storageService.clearStorage();
            window.location.href = window.location.origin + "/auth/login";
          } else {
            //generic error
            this.toastr.error("Problema di rete", err.error?.message, {
              positionClass: "toast-bottom-left",
            });
          }

          const skipLoader = this.skipLoaderService.getSkipLoader();
          if (!skipLoader) {
            this.loader.hide();
          }

          return throwError(err);
        })
      )
      .pipe(
        map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
          if (evt instanceof HttpResponse) {
            const skipLoader = this.skipLoaderService.getSkipLoader();
            if (!skipLoader) {
              this.loader.hide();
            }
          }
          return evt;
        })
      );
    return req;
  }
}
